import type { RenderLeafProps } from 'slate-react/dist/components/editable';

import { cn } from '@/shadcn/lib/utils';

export const Leaf = ({ attributes, children, leaf }: RenderLeafProps) => {
  let wrappedChildren = children;
  if (leaf.bold) {
    wrappedChildren = (
      <strong className="font-semibold">{wrappedChildren}</strong>
    );
  }
  if (leaf.italic) {
    wrappedChildren = <em className="italic">{wrappedChildren}</em>;
  }
  if (leaf.underline) {
    wrappedChildren = <u className="underline">{wrappedChildren}</u>;
  }

  if (leaf.highlight) {
    wrappedChildren = (
      <span
        className={cn('-mx-px -my-1 rounded-sm bg-yellow-200/70 px-px py-1')}
        data-cy="search-highlighted"
      >
        {wrappedChildren}
      </span>
    );
  }
  return <span {...attributes}>{wrappedChildren}</span>;
};

Leaf.displayName = 'Leaf';
